import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const REASONS = ["General Inquiry", "Event Information", "Venue Inquiry", "VIP/Table Inquiry", "Partnership", "Vendor", "Booking", "Other"];

export default function Contact() {
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", reason: "General Inquiry", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      setDone(true);
      toast.success("Message sent!");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  const field = "w-full rounded-md bg-[#1A1A1F] border border-[#27272A] px-4 py-3 text-white placeholder-zinc-500 outline-none focus:border-[#D4AF37]";

  if (done)
    return (
      <div className="mx-auto max-w-lg px-4 py-24 text-center">
        <h1 className="font-display text-4xl text-white uppercase">Message Sent</h1>
        <p className="text-zinc-400 mt-2">Thanks for reaching out — we'll be in touch soon.</p>
      </div>
    );

  return (
    <div className="mx-auto max-w-lg px-4 sm:px-6 py-10">
      <span className="section-eyebrow">Get In Touch</span>
      <h1 className="font-display text-4xl sm:text-5xl uppercase text-white mt-2 mb-6 leading-none">Contact ABE</h1>

      <form onSubmit={submit} className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <input data-testid="contact-first-name" required placeholder="First Name" value={form.first_name} onChange={set("first_name")} className={field} />
          <input data-testid="contact-last-name" required placeholder="Last Name" value={form.last_name} onChange={set("last_name")} className={field} />
        </div>
        <input data-testid="contact-email" required type="email" placeholder="Email Address" value={form.email} onChange={set("email")} className={field} />
        <input data-testid="contact-phone" placeholder="Phone Number" value={form.phone} onChange={set("phone")} className={field} />
        <Select value={form.reason} onValueChange={(v) => setForm((f) => ({ ...f, reason: v }))}>
          <SelectTrigger data-testid="contact-reason" className={field}><SelectValue /></SelectTrigger>
          <SelectContent>
            {REASONS.map((r) => <SelectItem key={r} value={r} data-testid={`reason-${r}`}>{r}</SelectItem>)}
          </SelectContent>
        </Select>
        <textarea data-testid="contact-message" required rows={5} placeholder="Your Message" value={form.message} onChange={set("message")} className={field} />
        <button data-testid="contact-submit" disabled={submitting} className="btn-gold w-full rounded-md py-3.5 font-oswald tracking-widest disabled:opacity-60">
          {submitting ? "SENDING…" : "SEND MESSAGE"}
        </button>
      </form>
    </div>
  );
}
